/**
 * Policy API Service
 * 
 * API calls for policy acceptance.
 */

import { apiClient } from "./apiClient";

export interface PolicyAcceptanceRequest {
  policy_type: "terms" | "privacy" | "risk";
  ip_address?: string;
  user_agent?: string;
}

export interface PolicyStatusResponse {
  user_id: string;
  policies: {
    [key: string]: {
      accepted: boolean;
      version: string;
    };
  };
}

/**
 * Accept policy
 */
export async function acceptPolicy(data: PolicyAcceptanceRequest): Promise<void> {
  await apiClient.post("/user/policy/accept", data);
}

/**
 * Get policy status
 */
export async function getPolicyStatus(): Promise<PolicyStatusResponse> {
  const response = await apiClient.get<PolicyStatusResponse>("/user/policy/status");
  return response.data;
}

